import 'css-chunk:src/components/SavingIndicator.module.scss';export default {
  "icon": "_icon_s84gq_9",
  "spin": "_spin_s84gq_23"
};